import React from 'react';
import { Helmet } from 'react-helmet-async';

const FaqSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How do I book airport parking through Airport Parking Deals?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Simply enter your airport, dates, and times on our homepage. We'll show you all available parking options with live prices. Select your preferred parking type (Park & Ride, Meet & Greet, or Onsite), compare providers, and complete your secure booking online in minutes."
        }
      },
      {
        "@type": "Question",
        "name": "What is the difference between Park & Ride and Meet & Greet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Park & Ride: You drive to an off-site car park, leave your car, and take a free shuttle bus to the terminal. This is the most budget-friendly option. Meet & Greet: You drive directly to the terminal, hand your keys to a professional driver who parks your car for you. Your car is returned to you when you land. This is the most convenient option."
        }
      },
      {
        "@type": "Question",
        "name": "Can I cancel or modify my parking booking?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, most parking providers offer flexible cancellation policies. The specific terms depend on the provider and the type of parking you've booked. You can check the cancellation policy during booking or contact our customer support team for assistance."
        }
      },
      {
        "@type": "Question",
        "name": "Is my car safe while I'm away?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. All parking facilities we list are secured with 24/7 CCTV monitoring, perimeter fencing, security patrols, and many hold Park Mark accreditation. Your vehicle is in safe hands throughout your trip."
        }
      },
      {
        "@type": "Question",
        "name": "How much can I save by booking through Airport Parking Deals?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "By comparing multiple providers and booking in advance, customers typically save up to 60% compared to on-the-day parking rates at the airport. The earlier you book, the better the deals."
        }
      },
      {
        "@type": "Question",
        "name": "Do you charge any booking fees?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No hidden fees! The price you see is the price you pay. We believe in transparent pricing with no surprise charges at checkout."
        }
      },
      {
        "@type": "Question",
        "name": "What happens if my flight is delayed?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Most parking providers offer grace periods for delays. If your flight is delayed, simply inform the car park when you collect your vehicle. Many providers include free grace periods, and others charge a small fee for extended stays."
        }
      },
      {
        "@type": "Question",
        "name": "Which airports do you cover?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We cover all major airports including Heathrow, Gatwick, Manchester, Stansted, Luton, Birmingham, Bristol, and many more across the country."
        }
      },
      {
        "@type": "Question",
        "name": "Will I receive a booking confirmation?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes! You'll receive instant email confirmation with all your booking details, parking instructions, contact numbers, and directions to the car park."
        }
      },
      {
        "@type": "Question",
        "name": "Can I add extras like car wash or cancellation cover?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, many providers offer optional extras such as car wash services, cancellation protection, and SMS notifications. You can add these during the booking process."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default FaqSchema;

